import Button from '../ui/Button';

function RejectedPage({ motivo, onSignOut }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-10">
      <div className="flex w-full max-w-md flex-col items-center gap-6 text-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Family Growers</h1>
          <p className="mt-1 text-sm text-gray-500">App de Campo</p>
        </div>

        <div className="w-full rounded-2xl border border-red-200 bg-red-50 p-6">
          <p className="font-medium text-red-800">Solicitud no aprobada</p>
          <p className="mt-3 text-sm text-red-700">
            Tu solicitud de acceso no fue aprobada. Si crees que se trata de un error, comunícate con el
            administrador.
          </p>
          {motivo && (
            <p className="mt-3 border-t border-red-200 pt-3 text-left text-sm text-red-700">
              <span className="font-medium">Motivo:</span> {motivo}
            </p>
          )}
        </div>

        <Button variant="secondary" className="max-w-xs" onClick={onSignOut}>
          Cerrar sesión
        </Button>
      </div>
    </div>
  );
}

export default RejectedPage;
